import { ChangeEvent } from 'react'

import { MyTrainingRequestsDatatableQuery } from 'generated/resources/datatable.graphql'

import useDataTable from 'modules/core/components/DataTable/hooks/useDataTable'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EmptyState } from './EmptyState'
import { MyRequestsDataTable } from './MyRequestsDataTable'

export function RequestsComponent({
  search,
  onSearch,
}: {
  search: string
  onSearch: (event: ChangeEvent<HTMLInputElement>) => void
}) {
  const datatable = useDataTable<MyTrainingRequestsDatatableQuery>()
  const canCreate = Boolean(
    datatable.queryResult.data?.trainings?._policies.trainingsRequestsCreate.can
  )
  const isEmpty =
    datatable.queryResult.data?.trainings?.trainingRequestsConnection.edges.length === 0 &&
    Object.getOwnPropertyNames(datatable.variables.filter).length === 0

  if (isEmpty) {
    return (
      <ResponsivePage.Body variant="full" showHeader={false}>
        <EmptyState
          canCreate={canCreate}
          emptyCatalog={
            datatable.queryResult?.data?.trainings?.trainingsConnection.edges.length === 0
          }
        />
      </ResponsivePage.Body>
    )
  }

  return (
    <ResponsivePage.Body variant="full">
      <MyRequestsDataTable canCreate={canCreate} search={search} onSearch={onSearch} />
    </ResponsivePage.Body>
  )
}
